import { useCurrentReglementQuery } from "../../stores/OkOkStore";
import { useTrads } from "../../contexts/trads/useTrads";
import { getByPath, uniqid } from "../../tools/utils";
import { type ChangeHandler,type FieldError,type FieldErrors } from "react-hook-form"
interface RegisterOutput {
    onChange:ChangeHandler,
    onBlur: ChangeHandler,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ref:	React.Ref<any>,
    name:	string
}
interface Props {
    name:string,
    label:string,
    type?:string,
    registerOutput:RegisterOutput,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    errors:FieldErrors<any>,
    rest?:Record<string,string|boolean|number>
}

function ReglementField({name,label,registerOutput,errors,rest}:Props){
   const {data, error,isLoading}=useCurrentReglementQuery();
    const {translate}=useTrads();
    const field_errors=getByPath(errors,name) as FieldError[];
    const id=uniqid("reglements");
    return (
            error ? (
                <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>
            ) : isLoading ? (
                <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
            ) : data ? (
                <>
                
                <div className={ "form-check " + (field_errors.length?" is-invalid":'')}>
                    <input 
                    role="switch" 
                    type="checkbox" 
                    className={"form-check-input " + (field_errors.length?" is-invalid":'')} 
                    id={id}
                    {...registerOutput} 
                    {...rest} 
                    value={data.id}
                    />
                    <label className="form-check-label" htmlFor={id}>{label}</label>
                </div>
                {field_errors.length>0 && <div className="invalid-feedback">{field_errors.map((error)=> <p key={error.message}>{translate(error.message)}</p>)}</div>}
                <a href={"/rgu"} target="_blank">{translate('lire_rgu')}</a>
                </>

            ):null
        );
}

export default ReglementField;